import { hide, show, toggle } from 'slidetoggle';
import { AccordionOptions } from './lib-2sxc-accordion-options';
import { Collapse } from 'bootstrap';
/*
  This is a shared code used in various 2sxc apps. Make sure that they are in sync, so if you improve it, improve all 2sxc apps which use this. 
  ATM they are:
  - Accordion
  - FAQ
  - App School System

  The master with the newest / best version must always be the Accordion, the others should then get a fresh copy.
  Because this is shared, all parameters like DOM-IDs etc. must be provided in the Init-call that it can work across apps
*/ 

export function initAccordion({ domId, options } : { domId: string, options: AccordionOptions }) {
  // get navHight for correct scrollposition
  var nav = (document.getElementsByTagName(options.tagStickyHeader)[0] as HTMLElement);
  var navHeight = (nav != null ? nav.offsetHeight : 0);

  var accordionOpener = document.querySelectorAll(`.app-accordion4-item > [${options.attrParent}]`);

  accordionOpener.forEach((elem: HTMLElement, index) => {
    const hash = elem.dataset.bsTarget.replace('#', '');
    const hashId = elem.dataset.bsTarget.replace('app-accordion4-', '');
    const accordionTarget = document.getElementById(hash);

    accordionTarget.addEventListener('show.bs.collapse', function () {
      location.hash = hashId;
    })    
  })

  // get hash from url and open specific item
  if(window.location.hash){
    const hash = window.location.hash.replace("#", "");
    const targetHashElem = document.querySelector(`[${options.attrParent}="#app-accordion4-${hash}"]`);
    const collapseTarget = document.querySelector(`#app-accordion4-${hash}`);
    
    // if target element exists scroll to element and open it
    if(targetHashElem){
      const elemOffsetX = targetHashElem.getBoundingClientRect().top + window.scrollY - navHeight;

      targetHashElem.classList.add('show')
      collapseTarget.classList.add('show')

      window.scrollTo({
        top: elemOffsetX,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
}